import { CircularProgress } from '@mui/material';

export const LoadingScreen = () => {
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                position: 'absolute',
                backgroundColor: '#fff',
                zIndex: '100',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <CircularProgress />
        </div>
    );
};
